module.exports = __webpack_public_path__ + "static/media/colored-hourglass.accc2919.svg";